import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationSearchNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M10.502 0a5.502 5.502 0 00-4.859 8.086l-4.35 4.35a.958.958 0 000 1.355l.916.915a.958.958 0 001.355 0l4.348-4.348A5.503 5.503 0 1010.502 0zM6.25 5.503a4.253 4.253 0 118.505 0 4.253 4.253 0 01-8.505 0zm.618 4.131l-3.981 3.982-.503-.503 3.982-3.982c.157.178.324.347.502.503z"
        fill=""
      />
    </svg>
  )
);
SvgNavigationSearchNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationSearchNormalXsmall;
